import { render, staticRenderFns } from "./ListadoPedidosObsequios.vue?vue&type=template&id=133ce044&scoped=true"
import script from "./ListadoPedidosObsequios.vue?vue&type=script&lang=js"
export * from "./ListadoPedidosObsequios.vue?vue&type=script&lang=js"
import style0 from "./ListadoPedidosObsequios.vue?vue&type=style&index=0&id=133ce044&prod&scoped=true&lang=css"
import style1 from "./ListadoPedidosObsequios.vue?vue&type=style&index=1&id=133ce044&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133ce044",
  null
  
)

export default component.exports